const $ = jQuery

export default class Window {
  constructor () {
    this.$el = $('body')
    this.last = 0
    this.handle()
  }
  
  handle () {
    $(window).on('scroll', event => {
      const st = window.pageYOffset || document.documentElement.scrollTop

      if (st > 10) {
        this.$el.addClass('state:scrolled')
      } else {
        this.$el.removeClass('state:scrolled')
      }

      if (st > this.last) {
        //down
        this.$el.addClass('state:up')
      } else {
        // up
        this.$el.removeClass('state:up')
      }

      this.last = st <= 0 ? 0 : st
    })
  }
}